export default {
  'component_refresh_btn_name': '刷新',
  'component_refresh_tips': '单击可刷新或每5分钟自动刷新一次.',
  'component_refresh_tips_10min': '单击可刷新或每10分钟自动刷新一次.',
  'component_refresh_tips_1hour': '单击可刷新或每小时自动刷新一次.',
  'component_refresh_success_msg': '刷新成功',
  'component_refresh_error_msg': '刷新失败',
}
